<template>
  <div class="work-experience">
    <!-- 列表展示 -->
    <template v-if="!edit">
      <div class="work-experience_empty" v-if="data.length === 0">暂无工作经历</div>

      <div class="work-experience_list" v-else>
        <div :class="['experience-item', { 'no-last': index < data.length - 1 }]" v-for="(item, index) in data" :key="index">
          <div class="experience-item_header">
            <div class="header-info">
              <div class="info-time">{{ item.start_time }}-{{ item.end_time }}</div>
              <div class="info-company">{{ item.company_name }}</div>
              <div class="info-split"></div>
              <div class="info-post">{{ item.position_name }}</div>
            </div>
            <div class="header-operate">
              <div class="operate-btn" @click="handleEdit(index)">
                <i class="el-icon-edit"></i>
                <span>编辑</span>
              </div>

              <div class="operate-btn" @click="handleDelete(item.work_id)">
                <i class="el-icon-delete-solid"></i>
                <span>删除</span>
              </div>
            </div>
          </div>
          <div class="experience-item_content">
            <div class="content-item">
              <div class="content-item_label">内容：</div>
              <div class="content-item_value">
                <p v-for="text in item.work_responsibilities.split('\n')">{{ text }}</p>
              </div>
            </div>

            <div class="content-item" v-if="item.work_performance">
              <div class="content-item_label">业绩：</div>
              <div class="content-item_value">
                <p v-for="text in item.work_performance.split('\n')">{{ text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 编辑 -->
    <template v-else>
      <el-form ref="form" :label-position="'top'" label-width="80px" :model="formData">
        <div class="row_box">
          <el-form-item label="公司名称">
            <el-input v-model="formData.company" placeholder="例如：北京华品博睿网络技术有限公司"></el-input>
          </el-form-item>

          <el-form-item label="所属行业">
            <el-cascader v-model="formData.industry" clearable :show-all-levels="false" style="width: 100%" :options="industryOption"></el-cascader>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="所属部门(选填)">
            <el-input v-model="formData.port" placeholder="例如：产品部"></el-input>
          </el-form-item>

          <el-form-item label="职位名称">
            <el-cascader v-model="formData.post" style="width: 100%" :show-all-levels="false" :options="positionOption"></el-cascader>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="在职时间">
            <el-date-picker v-model="formData.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="工作内容" style="width: 800px">
            <el-input v-model="formData.content" type="textarea" :placeholder="contentPlaceholder" resize="none" row="7"></el-input>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="工作业绩(选填)" style="width: 800px">
            <el-input v-model="formData.result" type="textarea" :placeholder="resultPlaceholder" resize="none" row="7"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import { positionOption, industryOption, getOptionArray } from "../js/data";

export default {
  data() {
    return {
      formData: {
        work_id: null,
        time: [], // 时间
        company: "", // 公司名称
        industry: "", // 行业
        port: "", // 部门
        post: [], // 岗位
        content: "", // 工作内容
        result: "", // 工作业绩
      },
      contentPlaceholder: `1、主要负责新员工入职培训;\n2、分析制定员工每月个人销售业绩;\n3、帮助员工提高每日客单价，整体店面管理等工作`,
      resultPlaceholder: `填写完整、有吸引力的工作业绩，有助于您更多吸引Boss的关注，例如\n1、取得的成绩...;\n2、实现的突破...\n3、获得的表彰...`,
      positionOption: positionOption,
      industryOption: industryOption,
      pickerOptions: {
        disabledDate: (time) => {
          const today = new Date();
          const endTime = new Date(
            `${today.getFullYear()}-${
              today.getMonth() + 1
            }-${today.getDate()} 00:00:00`
          );

          return time.getTime() > endTime;
        },
      },
    };
  },

  props: ["data", "edit", "experience"],

  methods: {
    initData() {
      this.$nextTick(() => {
        if (this.experience) {
          this.formData.work_id = this.experience.work_id;
          this.formData.time = [
            this.experience.start_time,
            this.experience.end_time,
          ]; // 时间
          this.formData.company = this.experience.company_name; // 公司名称
          this.formData.port = this.experience.department; // 部门
          this.formData.content = this.experience.work_responsibilities; // 工作内容
          this.formData.result = this.experience.work_performance; // 工作业绩
          this.formData.post = getOptionArray(
            this.positionOption,
            this.experience.position_name
          )[0];
          this.formData.industry = getOptionArray(
            this.industryOption,
            this.experience.industry
          )[0]

        }
      });
    },

    // 编辑
    handleEdit(index) {
      this.$emit("edit", index);
    },

    handleDelete(id) {
      this.$confirm("确定删除该工作经历?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delete", id);
      });
    },

    valid() {
      if (!this.formData.time) {
        this.$message.warning("请选择在职时间");
        return false;
      }

      if (!this.formData.company) {
        this.$message.warning("请输入公司名称");
        return false;
      }

      if (!this.formData.industry) {
        this.$message.warning("请选择所属行业");
        return false;
      }

      if (!this.formData.post) {
        this.$message.warning("请选择职位名称");
        return false;
      }

      if (!this.formData.content) {
        this.$message.warning("请输入工作内容");
        return false;
      }

      return true;
    },
  },

  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.work-experience {
  &_empty {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  &_list {
    .experience-item {
      & + .experience-item {
        margin-top: 16px;
      }

      padding-right: 48px;
      position: relative;

      &_header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-info,
        .header-operate {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .header-info {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #3b3b3b;

          .info-split {
            height: 16px;
            width: 1px;
            background-color: #d2d2d3;
          }
        }

        .header-operate {
          display: none;

          .operate-btn {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #685ef5;
            cursor: pointer;

            i {
              margin-right: 2px;
            }
          }
        }
      }

      &_content {
        .content-item {
          display: flex;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 16px;

          & > * {
            flex-shrink: 0;
          }

          &_label {
            width: 45px;
            text-wrap: nowrap;
          }

          &_value {
            flex: 1;
            text-wrap: wrap;
            word-break: break-all;

            p {
              margin: 0;
              word-break: break-all;
              text-wrap: wrap;
            }
          }
        }
      }

      &:hover {
        .header-operate {
          display: flex;
        }
      }

      &::before {
        position: absolute;
        content: "";
        top: 7px;
        left: -24px;
        width: 10px;
        height: 10px;
        background: #ffffff;
        border: 1px solid #d5d5d5;
        border-radius: 50%;
      }

      &.no-last {
        &::after {
          position: absolute;
          content: "";
          top: 20px;
          height: 100%;
          width: 2px;
          left: -19px;
          border-left: 1px dashed #d5d5d5;
        }
      }
    }
  }

  .row_box {
    width: 100%;
    display: flex;

    .el-form-item {
      flex-shrink: 0;
      width: 400px;
      margin-right: 40px;
    }
  }
}
</style>
